import { cons, ofArray, singleton, choose, empty, tryPick } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Action_Category, DomainEntities } from "../DomainEvents.fs.js";
import { System_DateTimeOffset__DateTimeOffset_ToLocaleDateString, EPM_Domain_Events_Maturity__Maturity_ToUrlString, EPM_Domain_Events_Action_Category__Category_ToUrlString, EPM_Domain_Events_Criticality__Criticality_ToUrlString, EPM_Domain_Events_Condition__Condition_ToUrlString, EPM_Domain_Events_Status__Status_ToUrlString, labelsToUrl } from "../Prelude.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";

function SearchParams_tryGetSearchParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 1) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetEntityIdParam(searchParams, domainEntity) {
    return tryPick((sp) => {
        let matchResult, domainEntityType_1, entityId_1;
        if (sp.tag === 2) {
            if (equals(domainEntity, sp.fields[1])) {
                matchResult = 0;
                domainEntityType_1 = sp.fields[1];
                entityId_1 = sp.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return entityId_1;
            default:
                return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetTargetEntityIdParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 3) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetMaturityParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 9) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetLabelsParam(searchParams, domainEntity) {
    return tryPick((sp) => {
        let matchResult, domainEntityType_1, labels_1;
        if (sp.tag === 5) {
            if (equals(domainEntity, sp.fields[0])) {
                matchResult = 0;
                domainEntityType_1 = sp.fields[0];
                labels_1 = sp.fields[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return labels_1;
            default:
                return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetConditionParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 7) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetStatusParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 6) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetCriticalityParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 8) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetProgressParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 10) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetUnplannedParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 11) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetDateRangeParam(searchParams) {
    return tryPick((sp) => {
        if (sp.tag === 12) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams);
}

function SearchParams_tryGetAttributesParam(searchParams) {
    return defaultArg(tryPick((sp) => {
        if (sp.tag === 13) {
            return sp.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams), empty());
}

export function SearchParams_facilitySearchParams(searchParams) {
    return choose((x) => x, singleton(map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams))));
}

export function SearchParams_moduleSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((facilityId) => ["facilityId", facilityId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(3, [])))]));
}

export function SearchParams_areaSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((facilityId) => ["facilityId", facilityId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(3, []))), map((moduleId) => ["moduleId", moduleId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(6, [])))]));
}

export function SearchParams_locationSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((facilityId) => ["facilityId", facilityId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(3, []))), map((moduleId) => ["moduleId", moduleId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(6, []))), map((areaId) => ["areaId", areaId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(7, [])))]));
}

export function SearchParams_productionUnitSearchParams(searchParams) {
    return choose((x) => x, singleton(map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams))));
}

export function SearchParams_systemSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((productionUnitId) => ["productionUnitId", productionUnitId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(13, [])))]));
}

export function SearchParams_subsystemSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((productionUnitId) => ["productionUnitId", productionUnitId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(13, []))), map((systemId) => ["systemId", systemId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(1, [])))]));
}

export function SearchParams_tagSearchParams(searchParams) {
    const search_2 = map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams));
    const productionUnitId_2 = map((productionUnitId) => ["productionUnitId", productionUnitId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(13, [])));
    const systemId_2 = map((systemId) => ["systemId", systemId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(1, [])));
    const subsystemId_2 = map((subsystemId) => ["subsystemId", subsystemId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(2, [])));
    const facilityId_2 = map((facilityId) => ["facilityId", facilityId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(3, [])));
    const moduleId_2 = map((moduleId) => ["moduleId", moduleId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(6, [])));
    const locationId_2 = map((locationId) => ["locationId", locationId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(8, [])));
    return choose((x) => x, ofArray([search_2, productionUnitId_2, systemId_2, subsystemId_2, facilityId_2, moduleId_2, map((areaId) => ["areaId", areaId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(7, []))), locationId_2, map((equipmentTypeId) => ["equipmentTypeId", equipmentTypeId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(10, []))), map((disciplineId) => ["disciplineId", disciplineId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(4, []))), map((labels) => ["labels", labelsToUrl(labels)], SearchParams_tryGetLabelsParam(searchParams, new DomainEntities(0, []))), map((status) => ["status", EPM_Domain_Events_Status__Status_ToUrlString(status)], SearchParams_tryGetStatusParam(searchParams)), map((condition) => ["condition", EPM_Domain_Events_Condition__Condition_ToUrlString(condition)], SearchParams_tryGetConditionParam(searchParams)), map((criticality) => ["criticality", EPM_Domain_Events_Criticality__Criticality_ToUrlString(criticality)], SearchParams_tryGetCriticalityParam(searchParams))]));
}

export function SearchParams_disciplineSearchParams(searchParams) {
    return choose((x) => x, singleton(map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams))));
}

export function SearchParams_equipmentTypeSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["Search", search], SearchParams_tryGetSearchParam(searchParams)), map((disciplineId) => ["disciplineId", disciplineId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(4, [])))]));
}

export function SearchParams_documentSearchParams(searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((labels) => ["labels", labelsToUrl(labels)], SearchParams_tryGetLabelsParam(searchParams, new DomainEntities(9, [])))]));
}

export function SearchParams_actionSearchParams(categoryOpt, searchParams) {
    return choose((x) => x, ofArray([map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((category) => ["category", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)], categoryOpt), map((labels) => ["labels", labelsToUrl(labels)], SearchParams_tryGetLabelsParam(searchParams, new DomainEntities(11, [])))]));
}

export function SearchParams_activitySearchParams(categoryOpt, searchParams) {
    const productionUnitId_2 = map((productionUnitId) => ["productionUnitId", productionUnitId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(13, [])));
    const systemId_2 = map((systemId) => ["systemId", systemId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(1, [])));
    const subsystemId_2 = map((subsystemId) => ["subsystemId", subsystemId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(2, [])));
    const facilityId_2 = map((facilityId) => ["facilityId", facilityId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(3, [])));
    const moduleId_2 = map((moduleId) => ["moduleId", moduleId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(6, [])));
    const locationId_2 = map((locationId) => ["locationId", locationId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(8, [])));
    const areaId_2 = map((areaId) => ["areaId", areaId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(7, [])));
    const equipmentTypeId_2 = map((equipmentTypeId) => ["equipmentTypeId", equipmentTypeId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(10, [])));
    const tagId_2 = map((tagId) => ["tagId", tagId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(0, [])));
    const disciplineId_2 = map((disciplineId) => ["disciplineId", disciplineId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(4, [])));
    const maturity_2 = map((maturity) => ["actionMaturity", EPM_Domain_Events_Maturity__Maturity_ToUrlString(maturity)], SearchParams_tryGetMaturityParam(searchParams));
    const actionCategory = map((category) => ["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)], categoryOpt);
    const labels_2 = map((labels) => ["requiredLabels", labelsToUrl(labels)], SearchParams_tryGetLabelsParam(searchParams, new DomainEntities(5, [])));
    const actionLabels = map((labels_3) => ["requiredActionLabels", labelsToUrl(labels_3)], SearchParams_tryGetLabelsParam(searchParams, new DomainEntities(11, [])));
    const progress_2 = map((progress) => {
        const progress_1 = progress;
        switch (progress_1) {
            case "toDo":
                return ["completed-status", "completed=false"];
            case "behind":
                return ["completed-status", `behind=${System_DateTimeOffset__DateTimeOffset_ToLocaleDateString(utcNow())}`];
            case "overHours":
                return ["completed-status", "overage=true"];
            default:
                return ["completed-status", "completed=true"];
        }
    }, SearchParams_tryGetProgressParam(searchParams));
    return choose((x) => x, ofArray([map((entityId) => ["entityId", entityId], SearchParams_tryGetTargetEntityIdParam(searchParams)), productionUnitId_2, systemId_2, subsystemId_2, facilityId_2, moduleId_2, areaId_2, locationId_2, equipmentTypeId_2, disciplineId_2, tagId_2, actionCategory, labels_2, actionLabels, progress_2, maturity_2, map((dateRange) => {
        const dateRange_1 = dateRange;
        return ["date-range", (dateRange_1.tag === 1) ? ((("completed=" + toString(dateRange_1.fields[0], "O")) + ";") + toString(dateRange_1.fields[1], "O")) : ((dateRange_1.tag === 2) ? ("expected=" + toString(dateRange_1.fields[0], "O")) : ((dateRange_1.tag === 3) ? ((("expected=" + toString(dateRange_1.fields[0], "O")) + ";") + toString(dateRange_1.fields[1], "O")) : ((dateRange_1.tag === 4) ? ((("falls-between=" + toString(dateRange_1.fields[0], "O")) + ";") + toString(dateRange_1.fields[1], "O")) : ((dateRange_1.tag === 5) ? ("falls-on=" + toString(dateRange_1.fields[0], "O")) : ("completed=" + toString(dateRange_1.fields[0], "O"))))))];
    }, SearchParams_tryGetDateRangeParam(searchParams)), map((actionId) => ["actionId", actionId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(11, []))), map((search) => ["search", search], SearchParams_tryGetSearchParam(searchParams)), map((actionTypeId) => ["actionTypeId", actionTypeId], SearchParams_tryGetEntityIdParam(searchParams, new DomainEntities(12, []))), map((unplanned) => ["unplanned", toString_1(unplanned)], SearchParams_tryGetUnplannedParam(searchParams))]));
}

export function SearchParams_dashboardSearchParams(categoryOpt, searchParams) {
    return cons(["attributes", join(",", SearchParams_tryGetAttributesParam(searchParams))], SearchParams_activitySearchParams(categoryOpt, searchParams));
}

export function EPM_App_EntityType__EntityType_ApiParams_180030EC(this$, typedParams) {
    switch (this$) {
        case "module":
            return SearchParams_moduleSearchParams(typedParams);
        case "area":
            return SearchParams_areaSearchParams(typedParams);
        case "location":
            return SearchParams_locationSearchParams(typedParams);
        case "productionUnit":
            return SearchParams_productionUnitSearchParams(typedParams);
        case "system":
            return SearchParams_systemSearchParams(typedParams);
        case "subsystem":
            return SearchParams_subsystemSearchParams(typedParams);
        case "tag":
            return SearchParams_tagSearchParams(typedParams);
        case "document":
            return SearchParams_documentSearchParams(typedParams);
        case "activity":
            return SearchParams_activitySearchParams(new Action_Category(0, []), typedParams);
        case "certification":
            return SearchParams_activitySearchParams(new Action_Category(1, []), typedParams);
        case "punchList":
            return SearchParams_activitySearchParams(new Action_Category(2, []), typedParams);
        case "documentTracking":
            return SearchParams_activitySearchParams(new Action_Category(3, []), typedParams);
        case "preservation":
            return SearchParams_activitySearchParams(new Action_Category(4, []), typedParams);
        case "technicalQuery":
            return SearchParams_activitySearchParams(new Action_Category(5, []), typedParams);
        case "nonConformanceReport":
            return SearchParams_activitySearchParams(new Action_Category(6, []), typedParams);
        case "scopeOfWork":
            return SearchParams_activitySearchParams(undefined, typedParams);
        default:
            return SearchParams_facilitySearchParams(typedParams);
    }
}

